export default __webpack_public_path__ + "static/promo1-0a5bb31522d9bdd7b3614d73a9894bbb.mp4";